import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesSmallCardWithDotProps {
  children: React.ReactNode;
  className?: string;
}

export const CasesSmallCardWithDot = ({
  children,
  className,
}: CasesSmallCardWithDotProps) => {
  return (
    <div
      className={classNames({
        cls: 'flex rounded-[20px] bg-[linear-gradient(90deg,_rgba(255,255,255,0.0576)_0%,_rgba(255,255,255,0.0048)_100%)] p-[20px] max-sm:bg-[linear-gradient(90deg,_rgba(255,255,255,0.0576)_0%,_rgba(255,255,255,0.0144)_100%)]',
        additional: [className],
      })}
    >
      <div className="bg-status-accent mt-2 mr-2 h-3 w-3 min-w-3 rounded-full max-sm:mt-[6px]"></div>

      <p className="text-text-base-primary text-[16px] leading-[28px] max-lg:text-[16px] max-lg:leading-[24px]">
        {children}
      </p>
    </div>
  );
};
